<template>
  <div class="person-intro" v-if="!isEmpty(author)">
    <div class="row d-flex justify-content-center" v-if="!isEmpty(image)">
      <img class="img-fluid thumbnail" v-lazy="image" :alt="title">
    </div>
    <div class="introduction">
      <div class="row justify-content-start pl-3 pr-3 pb-2 no-gutters">
        <div class="col authorName">
          <term-link :tid="author.tid" :title="author.title" :url="author.relative_url" :type="author.type">{{author.title}}</term-link>
        </div>
      </div>
      <div class="no-gutters row align-items-start pl-3 pr-3" v-if="links">
        <a class="social-box" v-for="link in links" :key="link.type" :href="link.link" target="_blank">
          <component v-bind:is="link.type" class="social-icon" :class="classes(link.type)">
          </component>
        </a>
      </div>
      <div v-if="bio" class="row intro-text p-3 ">
        <div class="col-12">
          {{bio}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import forEach from 'lodash/forEach'
import isEmpty from 'lodash/isEmpty'
import Facebook from 'static/svg/icon_facebook.svg'
import Twitter from 'static/svg/icon_twitter.svg'
import Instagram from 'static/svg/icon_instagram.svg'
import Email from 'static/svg/icon_email1.svg'
import TermLink from 'components/term/Link'

export default {
  name: 'person-intro',
  props: ['nid'],
  components: {
    Facebook,
    Twitter,
    Email,
    Instagram,
    TermLink,
  },
  computed: {
    node() {
      return this.$store.getters.node(this.nid)
    },
    author() {
      return this.$store.getters.term(get(this, 'node.authors[0]'))
    },
    image() {
      return get(this, 'author.images[0].style_square', '')
    },
    title() {
      return get(this, 'author.title', '')
    },
    links() {
      const links = []
      if (get(this, 'author.links')) {
        const weight = ['facebook', 'twitter', 'instagram', 'email']
        forEach(weight, (value) => {
          if (get(this.author.links, value)) {
            links.push({type: value, link: get(this.author.links, value)})
          }
        })
      }
      return links
    },
    bio() {
      return get(this, 'author.bio', false)
    },
  },
  methods: {
    isEmpty,
    classes(key) {
      return [`social-icon-${key}`]
    },
  },
}
</script>

<style lang="scss" scoped>
.person-intro {
  padding: rem-calc(20 0);
  color: $white;
  font-family: $barlow;
  font-size: rem-calc(16);

  .thumbnail{
    width: rem-calc(200);
    height: rem-calc(200);
  }

  .introduction {
    @include create-speech-balloon($black, 35, 37);
    padding: rem-calc(20 0);
    margin: rem-calc(-10) auto rem-calc(45) auto;
    color: $rose;
    width: rem-calc(280);
    @include respond-to('desktop') {
      margin: rem-calc(-10) auto rem-calc(57) auto;
    }

    .authorName {
      font-weight: bold;
      font-size: rem-calc(20);
    }

    .social-box {
      width: rem-calc(28);
      height: rem-calc(28);
      background: $rose;
      border-radius: 50%;
      & ~ .social-box {
        margin-left: rem-calc(12);
      }
      svg {
        height: 100%;
        width: rem-calc(14);
        display: block;
        margin: 0 auto;
        &.social-icon-facebook {
          width: rem-calc(7);
        }
      }
    }

    .intro-text{
      color: $white;
      margin-top: rem-calc(-5);
    }

    .social-icon path {
      fill: $white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PersonIntro.vue?6c7b6e89